module.exports = __webpack_public_path__ + "img/ptt.1aea81bc.png";